<template>
  <section>
    <ChartWarningForIE
      v-if="chartWarning"
      @click="chartWarning = false"
    />
    <!-- 그래프 -->
    <div v-else class="section_graph">
      <Chart v-if="tableItems" :chartData="tableItems" :key="chartKey"></Chart>
      <div v-else style="font-size:15px; text-align:center;">
        <div>
          <span>조회결과가 없습니다.</span>
        </div>
      </div>
    </div>
    <!-- //그래프 -->

    <PlainTable ref="table" :sourceList="tableItems" :useExcel="true">
      <template #header>
        <caption>
          <span class="blind">통계 목록</span>
        </caption>
        <colgroup>
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
        </colgroup>

        <thead class="table_list_head table_list_head_line">
          <tr>
            <th rowspan="2">날짜</th>
            <th rowspan="2">대상자수</th>
            <th colspan="6">호출건수</th>
            <th colspan="2">일반소식</th>
            <th colspan="2">반복소식</th>
            <th>맞춤소식</th>
          </tr>
          <tr>
            <th>전체</th>
            <th>소식톡톡</th>
            <th>두뇌톡톡</th>
            <th>기억검사</th>
            <th>좋은생각</th>
            <th>마음체조</th>
            <th>전송</th>
            <th>확인</th>
            <th>전송</th>
            <th>확인</th>
            <th>전송</th>
          </tr>
        </thead>
      </template>
      <template #row="{rowData}">
        <tr>
          <td>{{rowData.date}}</td>
          <td class="right">{{rowData.rcpCount}}</td>
          <td class="right">{{rowData.utteranceRequest_allCount}}</td>
          <td class="right">{{rowData.utteranceRequest_newsCount}}</td>
          <td class="right">{{rowData.utteranceRequest_gameCount}}</td>
          <td class="right">{{rowData.utteranceRequest_dementiaCount}}</td>
          <td class="right">{{rowData.utteranceRequest_goodCount}}</td>
          <td class="right">{{rowData.utteranceRequest_mindCount}}</td>
          <td class="right">{{rowData.normalNews_sendCount}}</td>
          <td class="right">{{rowData.normalNews_readCount}}</td>
          <td class="right">{{rowData.repeatNews_sendCount}}</td>
          <td class="right">{{rowData.repeatNews_readCount}}</td>
          <td class="right">{{rowData.customNews_sendCount}}</td>
        </tr>
      </template>
    </PlainTable>
    <!-- 버튼 영역 -->
    <div class="section_button none_paginate">
      <ExcelDownloadButton
        :filename="excelFileName"
        :table="$refs.table && $refs.table.$el.querySelector('table')"
      />
      <HelpButton contentId="HELP_02" />
    </div>
  </section>
</template>

<script>
import Chart from "./Chart";
import XLSX from "xlsx";
import ChartWarningForIE from "$views/Stats/ChartWarningForIE";

const defaultItemData = {
  date: "-",
  rcpCount: 0,
  utteranceRequest: {
    allCount: 0,
    newsCount: 0,
    gameCount: 0,
    dementiaCount: 0,
    healthCount: 0,
    goodCount: 0,
    mindCount: 0
  },
  normalNews: { sendCount: 0, readCount: 0 },
  repeatNews: { sendCount: 0, readCount: 0 },
  customNews: { sendCount: 0 }
};

export default {
  props: {
    statData: Array,
    excelFileName: {
      type: String,
      default: "table"
    }
  },
  data() {
    return {
      chartWarning: this.$utils.isIE,
      chartKey: Date.now()
    };
  },
  watch: {
    statData() {
      this.chartKey = Date.now();
    }
  },
  components: { Chart, ChartWarningForIE },
  computed: {
    // 차트에서 쓰이도록 flat하게 재정의
    tableItems() {
      if (_.isEmpty(this.statData)) return null;
      return _.map(this.statData, item => {
        const mergedItem = _.mergeWith(
          {},
          defaultItemData,
          item,
          (resultValue, sourceValue) => {
            return sourceValue || resultValue;
          }
        );
        return {
          date: mergedItem.date,
          rcpCount: mergedItem.rcpCount,
          utteranceRequest_allCount: mergedItem.utteranceRequest.allCount,
          utteranceRequest_newsCount: mergedItem.utteranceRequest.newsCount,
          utteranceRequest_gameCount: mergedItem.utteranceRequest.gameCount,
          utteranceRequest_dementiaCount:
            mergedItem.utteranceRequest.dementiaCount,
          utteranceRequest_goodCount: mergedItem.utteranceRequest.goodCount,
          utteranceRequest_mindCount: mergedItem.utteranceRequest.mindCount,
          normalNews_sendCount: mergedItem.normalNews.sendCount,
          normalNews_readCount: mergedItem.normalNews.readCount,
          repeatNews_sendCount: mergedItem.repeatNews.sendCount,
          repeatNews_readCount: mergedItem.repeatNews.readCount,
          customNews_sendCount: mergedItem.customNews.sendCount
        };
      });
    }
  }
};
</script>
